// Filename: uicanvasportalbg.js
// Timestamp: 2017.11.19-13:42:21 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

import {
  render,
  rendererResizeWH
} from './uithree.js'

import uicanvasportal from './uicanvasportal.js'

const xonframe = (ss, cfg, gr, nd, pg, rafcfg) => {
  pg.updatechildseq(ss, cfg, gr, nd, rafcfg)

  render(rafcfg)
}

const xonresize = (ss, cfg, gr, node, pg, rafcfg, subj) => {
  if (pg.isresized(ss, cfg, gr, node, rafcfg)) {
    pg.rebuildscene(ss, cfg, gr, node, pg, rafcfg, subj)
  }
}

// override uicanvas resetcanvas
const resetcanvas = (node, canvas) => canvas

const xonattach = (ss, cfg, gr, nd, pg, prev, subj) => {
  prev.hasloaded = true

  prev = pg.initialstagestate(ss, cfg, gr, nd, prev)
  prev = pg.rebuildscene(ss, cfg, gr, nd, pg, prev, subj)
  prev.wharr = pg.getglcanvaswh(cfg, nd)

  // suppose viewport is 800x800
  // canvas is 800x400 and is 77.5 pixels from top
  //  * a centered, height-scaled-canvas could fit inside viewport
  //    with additional height 155 (77.5 * 2)
  // if larger canvas 800x600 is added, out-of-bounds height is
  // 23.5 ((200 - 155) / 2)
  const elemstage = document.getElementById(':bgtarget:bgtargetstage')
  const heightextra = elemstage.getBoundingClientRect().top + window.pageYOffset
  const heightstage = elemstage.offsetHeight
  const heightincrease = prev.wharr[1] - heightstage
  const heightremainder = heightextra * 2
  const offset = (heightincrease - heightremainder) / 2

  rendererResizeWH(
    cfg.THREE,
    prev.glrenderer,
    [prev.wharr[0], prev.wharr[1]],
    prev.camera,
    offset)

  render(prev)
}

export default Object.assign({}, uicanvasportal, {
  type: 'uicanvasportalbg',
  xonframe,
  xonresize,
  xonattach,

  resetcanvas
})
